






















import { plainToInstance } from 'class-transformer'
import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Prop, VModel, Watch } from 'vue-property-decorator'

import {
  BotProperty,
  GroupedBotProperty,
} from '../../../../../../../../../../BotProperties/components/Properties/types'
import BaseCondition from '../../../../logic/ConditionTypes/BaseCondition'
import BetweenCondition from '../../../../logic/ConditionTypes/BetweenPropertyCondition'
import PropertyCondition, {
  PropertyConditionAction
  } from '../../../../logic/ConditionTypes/PropertyCondition'
import IsNotSetPropertyCondition
  from '../../../../logic/ConditionTypes/SetPropertyConditions/IsNotSetPropertyCondition'
import IsSetPropertyCondition
  from '../../../../logic/ConditionTypes/SetPropertyConditions/IsSetPropertyCondition'
import SetPropertyCondition from '../../../../logic/ConditionTypes/SetPropertyConditions/SetPropertyCondition'
import { SetPropertyActionValue } from '../../../../logic/PropertyConditionValues/BaseValue'
import PropertyValue from '../../../../logic/PropertyConditionValues/PropertyValue'
import { ConditionType } from '../../../../logic/types'
import { getCompatibleConditions } from './PropertyConditionUtils'

@Component({
  data() {
    return {
      snakeCase,
    }
  }
})
export default class PropertyConditionParams extends Vue {
  @VModel() condition!: BaseCondition

  @Prop() properties!: Array<BotProperty>

  @Prop() selectedProperty!: GroupedBotProperty | undefined

  @Watch('selectedProperty')
  conditionWatcher(): void {
    this.selectedCondition = null
  }

  selectedCondition: PropertyConditionAction | ConditionType | null = null

  get propertyGroup() {
    return this.selectedProperty?.group ?? 'custom'
  }

  get compatibleConditions(): Array<PropertyConditionAction> | null {
    if (this.selectedProperty) {
      return getCompatibleConditions(this.selectedProperty)
    }

    return null
  }

  selectConditionType(type: PropertyConditionAction): void {
    if (type !== this.selectedCondition) {
      this.selectedCondition = type

      switch (type) {
        case PropertyConditionAction.More:
        case PropertyConditionAction.Less:
        case PropertyConditionAction.MoreOrEquals:
        case PropertyConditionAction.LessOrEquals:
        case PropertyConditionAction.Equals:
        case PropertyConditionAction.Contains:
        case PropertyConditionAction.StartsWith:
        case PropertyConditionAction.EndsWith:
          this.condition = plainToInstance(PropertyCondition, {
            type: ConditionType.Property,
            action: type,
            options: [],
            left: plainToInstance(PropertyValue, {
              type: SetPropertyActionValue.Property,
              property_index: this.selectedProperty?.id,
              transform: null,
            }),
            right: plainToInstance(PropertyValue, {
              type: SetPropertyActionValue.Constant,
              value: ''
            }),
            invert: false,
          })
          break
        case PropertyConditionAction.FlagProp:
          this.condition = plainToInstance(PropertyCondition, {
            type: ConditionType.Property,
            left: {
              type: SetPropertyActionValue.Property,
              property_index: this.selectedProperty?.id,
              transform: null
            },
            right: {
              type: SetPropertyActionValue.Property,
              property_index: null,
              transform: null,
            },
            action: PropertyConditionAction.Equals,
            options: [],
            invert: false,
          })
          break
        case PropertyConditionAction.True:
        case PropertyConditionAction.False:
          this.condition = plainToInstance(PropertyCondition, {
            type: ConditionType.Property,
            left: {
              type: SetPropertyActionValue.Property,
              property_index: this.selectedProperty?.id,
              transform: null
            },
            right: {
              type: SetPropertyActionValue.Constant,
              value: type === PropertyConditionAction.True ? 1 : 0
            },
            action: PropertyConditionAction.Equals,
            options: [],
            invert: false,
          })
          break
        case PropertyConditionAction.IsSet:
          this.condition = plainToInstance(IsSetPropertyCondition, {
            type: ConditionType.IsSetProperty,
            property_index: this.selectedProperty?.id,
            invert: false,
          })
          break
        case PropertyConditionAction.IsNotSet:
          this.condition = plainToInstance(IsNotSetPropertyCondition, {
            type: ConditionType.IsNotSetProperty,
            property_index: this.selectedProperty?.id,
            invert: false,
          })
          break
        case PropertyConditionAction.BetweenProperty:
          this.condition = plainToInstance(BetweenCondition, {
            type: ConditionType.BetweenProperty,
            left: {
              type: SetPropertyActionValue.Property,
              property_index: this.selectedProperty?.id,
              transform: null
            },
            from: {
              type: SetPropertyActionValue.Constant,
              value: '',
            },
            to: {
              type: SetPropertyActionValue.Constant,
              value: '',
            },
            invert: false,
          })
      }
    }
  }

  created() {
    if (this.condition instanceof PropertyCondition) {
      this.selectedCondition = this.condition.action
    }

    if (this.condition instanceof SetPropertyCondition) {
      this.selectedCondition = this.condition.type
    }
  }
}
